import React from 'react';

const AvisInformacioAddicionalMonitoritzacioRadarLlegenda = () => {
    return (
        <div id="legend" className="radar">
            <div className="legend-title">Intensitat de precipitaci&oacute;</div>
            <ul className="legend-colors">
                <li style={{'backgroundColor':'#8000FF'}}></li>
                <li style={{'backgroundColor':'#4000FF'}}></li>
                <li style={{'backgroundColor':'#0000FF'}}></li>
                <li style={{'backgroundColor':'#00FFFF'}}></li>
                <li style={{'backgroundColor':'#00FF80'}}></li>
                <li style={{'backgroundColor':'#00FF00'}}></li>
                <li style={{'backgroundColor':'#3FFF00'}}></li>
                <li style={{'backgroundColor':'#7FFF00'}}></li>
                <li style={{'backgroundColor':'#BFFF00'}}></li>
                <li style={{'backgroundColor':'#FFFF00'}}></li>
                <li style={{'backgroundColor':'#FFAB00'}}></li>
                <li style={{'backgroundColor':'#FF8100'}}></li>
                <li style={{'backgroundColor':'#FF5700'}}></li>
                <li style={{'backgroundColor':'#FF2D00'}}></li>
                <li style={{'backgroundColor':'#FF0000'}}></li>
                <li style={{'backgroundColor':'#FF003F'}}></li>
                <li style={{'backgroundColor':'#FF007F'}}></li>
                <li style={{'backgroundColor':'#FF00BF'}}></li>
                <li style={{'backgroundColor':'#FF00FF'}}></li>
                <li style={{'backgroundColor':'#FFF'}}></li>
            </ul>
            <div className="legend-labels">
                <span>feble</span>
                <span>moderada</span>
                <span>forta</span>
                <span>calamarsa</span>
            </div>
        </div>
    );
};

export default AvisInformacioAddicionalMonitoritzacioRadarLlegenda;



// WEBPACK FOOTER //
// ./src/components/avis/avisInformacioAddicionalMonitoritzacioRadarLlegenda.js